<template>
  <div class="leaderboard-table">
    <LeaderBoardTableHeading :heading-items="headingItems" />
    <LeaderBoardTableRow
      v-for="(item, index) in tableItems"
      :key="item.id"
      :table-item="item"
      :divider="divider"
      :index="index"
    />
  </div>
</template>

<script>
import LeaderBoardTableHeading from "./LeaderBoardTableHeading";
import LeaderBoardTableRow from "./LeaderBoardTableRow";
export default {
  name: "LeaderBoardTable",
  components: {
    LeaderBoardTableRow,
    LeaderBoardTableHeading
  },
  props: ["tableItems", "headingItems", "divider"]
};
</script>

<style scoped>
.leaderboard-table {
  width: 100%;
  text-align: left;
}
.leaderboard-table__heading {
  margin-bottom: 15px;
}
</style>
